import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex);

// 主に全体で使用する変数をStoreで保持します。
export default new Vuex.Store({
  state: {
    // トークン
    idToken: "",
    accessToken: "",
    refreshToken: "",
    // 認証済みフラグ
    isAuthenticated: false,
    // ログイン済みフラグ
    isLogin: false,
    // 管理者フラグ
    isAdmin: false,
    // 管理者情報
    adminUser: "",
    // 担当者情報
    chargeId: "",
    municipalityKey: "",
    isPushAuth: false,
    isSoundAuth: false,
    groups: null,

    /*
    以下画面リロード対策
    各画面に必要な値をStoreに保存
    */
    // 変更フラグ
    changeFlg: false,
    // 地域詳細画面で使用
    areaId: "",
    // 災害種別詳細画面で使用
    disasterId: "",
    // リンク詳細画面で使用
    linkId: "",
    linkLanguage: "",
    prevRoute: "",
    // プッシュ通知詳細画面で使用
    pushId: "",
    // 担当者(課)一覧画面で使用
    selectMunicipalityKey: "",
    // 担当者(課)詳細画面で使用
    selectChargeId: "",
    // プッシュ訓練通知詳細画面で使用
    pushTrainingId: "",
    trainingName: "",
    // 印刷設定編集画面で使用
    printDisasterId: "",
    // お知らせ
    notificationId: "",
    // 地域グループ
    groupId: "",
    // テンプレートフラグ(push)
    templateFlg: "",
    pushTemplateUpdateFlg: "",
    // 民間対応
    companyId: "",
    companyFlg: "",
    companyCognitoUserStatus: "",
    // 避難場所
    shelterId: "",
  },
  getters: {
    getStateIdToken(state) {
      return state.idToken
    },
    getStateAccessToken(state) {
      return state.accessToken
    },
    getStateRefreshToken(state) {
      return state.refreshToken
    },
    getStateIsAuthenticated(state) {
      return state.isAuthenticated
    },
    getStateIsLogin(state) {
      return state.isLogin
    },
    getStateIsAdmin(state) {
      return state.isAdmin
    },
    getStateAdminUser(state) {
      return state.adminUser
    },
    getStateChargeId(state) {
      return state.chargeId
    },
    getStateMunicipalityKey(state) {
      return state.municipalityKey
    },
    getStateIsPushAuth(state) {
      return state.isPushAuth
    },
    getStateIsSoundAuth(state) {
      return state.isSoundAuth
    },
    getStateGroups(state) {
      return state.groups
    },
    getStateChangeFlg(state) {
      return state.changeFlg
    },
    getStateAreaId(state) {
      return state.areaId
    },
    getStateDisasterId(state) {
      return state.disasterId
    },
    getStateLinkId(state) {
      return state.linkId
    },
    getStateLinkLanguage(state) {
      return state.linkLanguage
    },
    getStatePrevRoute(state) {
      return state.prevRoute
    },
    getStatePushId(state) {
      return state.pushId
    },
    getStateSelectMunicipalityKey(state) {
      return state.selectMunicipalityKey
    },
    getStateSelectChargeId(state) {
      return state.selectChargeId
    },
    getStatePushTrainingId(state) {
      return state.pushTrainingId
    },
    getStateTrainingName(state) {
      return state.trainingName
    },
    getStatePrintDisasterId(state) {
      return state.printDisasterId;
    },
    getStateNotificationId(state) {
      return state.notificationId;
    },
    getStateGroupId(state) {
      return state.groupId;
    },
    getStateTemplateFlg(state) {
      return state.templateFlg
    },
    getStatePushTemplateUpdateFlg(state) {
      return state.pushTemplateUpdateFlg
    },
    getStateCompanyId(state) {
      return state.companyId
    },
    getStateCompanyFlg(state) {
      return state.companyFlg
    },
    getStateCompanyCognitoUserStatus(state) {
      return state.companyCognitoUserStatus
    },
    getStateShelterId(state) {
      return state.shelterId
    }
  },
  mutations: {
    setStateIdToken(state, idToken) {
      state.idToken = idToken
    },
    setStateAccessToken(state, accessToken) {
      state.accessToken = accessToken
    },
    setStateRefreshToken(state, refreshToken) {
      state.refreshToken = refreshToken
    },
    setStateIsAuthenticated(state, isAuthenticated) {
      state.isAuthenticated = isAuthenticated
    },
    setStateIsLogin(state, isLogin) {
      state.isLogin = isLogin
    },
    setStateIsAdmin(state, isAdmin) {
      state.isAdmin = isAdmin
    },
    setStateAdminUser(state, adminUser) {
      state.adminUser = adminUser
    },
    setStateChargeId(state, chargeId) {
      state.chargeId = chargeId
    },
    setStateMunicipalityKey(state, municipalityKey) {
      state.municipalityKey = municipalityKey
    },
    setStateIsPushAuth(state, isPushAuth) {
      state.isPushAuth = isPushAuth
    },
    setStateIsSoundAuth(state, isSoundAuth) {
      state.isSoundAuth = isSoundAuth
    },
    setStateGroups(state, municipality_key) {
      axios.get(process.env.VUE_APP_API_BASEURL + 'link/group', {
        params: {
          municipality_key: municipality_key
        }
      }).then((response) => {
        state.groups = response.data
      })
    },
    addStateGroups(state, dic_group) {
      state.groups.push(dic_group)
    },
    setStateChangeFlg(state, changeFlg) {
      state.changeFlg = changeFlg
    },
    setStateAreaId(state, areaId) {
      state.areaId = areaId
    },
    setStateDisasterId(state, disasterId) {
      state.disasterId = disasterId
    },
    setStateLinkId(state, linkId) {
      state.linkId = linkId
    },
    setStateLinkLanguage(state, linkLanguage) {
      state.linkLanguage = linkLanguage
    },
    setStatePrevRoute(state, prevRoute) {
      state.prevRoute = prevRoute
    },
    setStatePushId(state, pushId) {
      state.pushId = pushId
    },
    setStateSelectMunicipalityKey(state, selectMunicipalityKey) {
      state.selectMunicipalityKey = selectMunicipalityKey
    },
    setStateSelectChargeId(state, selectChargeId) {
      state.selectChargeId = selectChargeId
    },
    setStatePushTrainingId(state, pushTrainingId) {
      state.pushTrainingId = pushTrainingId
    },
    setStateTrainingName(state, trainingName) {
      state.trainingName = trainingName
    },
    setStatePrintDisasterId(state, disasterId) {
      state.printDisasterId = disasterId;
    },
    setStateNotificationId(state, notificationId) {
      state.notificationId = notificationId;
    },
    setStateGroupId(state, groupId) {
      state.groupId = groupId;
    },
    setStateTemplateFlg(state, templateFlg) {
      state.templateFlg = templateFlg
    },
    setStatePushTemplateUpdateFlg(state, pushTemplateUpdateFlg) {
      state.pushTemplateUpdateFlg = pushTemplateUpdateFlg
    },
    setStateCompanyId(state, companyId) {
      state.companyId = companyId
    },
    setStateCompanyFlg(state, companyFlg) {
      state.companyFlg = companyFlg
    },
    setStateCompanyCognitoUserStatus(state, companyCognitoUserStatus) {
      state.companyCognitoUserStatus = companyCognitoUserStatus
    },
    setStateShelterId(state, shelterId) {
      state.shelterId = shelterId
    },
    logout(state) {
      state.idToken = null;
      state.accessToken = null;
      state.refreshToken = null;
    },
  },
  actions: {
    getStateGroupList(context, municipality_key) {
      context.commit('setStateGroups', municipality_key)
    }
  },
  // Store保持用プラグイン
  plugins: [createPersistedState()]
});